import { render, staticRenderFns } from "./MoleculeEditionAcademyLegalsPrivacyPolicies.vue?vue&type=template&id=12ca7ca7&"
import script from "./MoleculeEditionAcademyLegalsPrivacyPolicies.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyLegalsPrivacyPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports